module.exports = __webpack_public_path__ + "img/image16_2.c8fe5e4f.png";